import { observable, action, makeObservable, set } from 'mobx';

import { ProductUnitType } from '../../shared/support/modelTypes';

export interface ProductUnitFormStoreType {
	model: ProductUnitType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	collectedModels: Array<any>;
	filterInclude?: Array<any>;
	selectedItems: Array<any>;
	isFirstLoad: boolean;
	name: string;
	setValue(model: any, key: string, value: any): void;
}

class ProductUnitFormStore implements ProductUnitFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			collectedModels: observable,
			selectedItems: observable,
			filterInclude: observable,
			isFirstLoad: observable,
			name: observable,
			setValue: action
		});
	}

	model = {
		baseUnitId: null,
		unitId: '',
		deleted: false,
		displayName: null,
		elementType: 0,
		name: { ru: '' },
		ownerId: null,
		ownerType: null,
		packageTypeId: 'unit_package_types.final',
		parentId: null,
		priority: null,
		quantityOfOwnerUnitIncludedInPackage: 0,
		quantityOfPackageIncludedInOwnerUnit: 1,
		quantityOfParentPackageIncludedInPackage: 0,
		typeId: null,
		packageType: {
			description: null,
			keyId: 'final',
			id: 'unit_package_types.final',
			name: { ru: 'Конечная' },
			ownerId: 'unit_package_types',
			predefined: true,
			predefinedName: 'UnitPackageTypesFinal',
			predefinedVersion: 0
		}
	};
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	pluralName = 'productUnits';
	filterInclude = ['unit', 'type', 'packageType'];
	collectedModels = [] as Array<any>;
	selectedItems = [] as Array<any>;
	isFirstLoad = true;
	name = 'OrmProductUnit';
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const productUnitsFormStore = new ProductUnitFormStore();

export default ProductUnitFormStore;
